<template>
  <div class="lottoBetPage" :key="componentKey">
    <div id="section-content" class="container container-fluid">
      <app-content1 />
      <div
        class="p-2 w-100 bg-light main-content align-self-stretch d-flex flex-column align-items-stretch"
        style="min-height: calc((100vh - 189px) - 50px)" v-if="!endTime">

        <app-content2 v-on:setEndTime="endTime = $event" />
        <div class="row-menu-grid">
          <app-content3 @openPrice="togglePrice($event)" @openSet="toggleSet($event)" :numberSets="setNumber"/>
          <app-content4/>
        </div>
      </div>
    </div>
    <app-confirm-model />
    <transition name="slide-fade">
      <app-price-modal @exitPrice="toggleExit($event)" @openSend="toggleSend($event)" v-if="showModal" :limits="getInquiryRoundInfomation ? getInquiryRoundInfomation.price_limit : []" :sumNumber="getInquiryRoundInfomation ? getInquiryRoundInfomation.limitNumber : []" />
    </transition>
    <transition name="slide-fade">
      <app-send-modal
        :data="getInquiryRoundInfomation"
        @closeSend="toggleSend($event)"
        @openPrint="togglePrint($event)"
        v-if="showSend"
      />
    </transition>
    <transition name="slide-fade">
      <app-print-modal
        @closePrint="togglePrint($event)"
        v-if="showPrint"
        :data="getInquiryRoundInfomation"
      />
    </transition>
    <transition name="slide-fade">
      <app-setnumber-modal v-if="showSet" @closeSet="toggleSet($event)" @sendSet="setNumber = $event"/>
    </transition>
    <app-clearing-modal @closePrice="togglePrice($event)" />
  </div>
</template>
<script>
import ConfirmBetModal from '@/components/modals/ConfirmBetModal'
import content1 from '@/pages/lottoBetPage/content/content1'
import content2 from '@/pages/lottoBetPage/content/content2'
import content3 from '@/pages/lottoBetPage/content/content3'
import content4 from '@/pages/lottoBetPage/content/content4'
import pricemodal from '@/components/modals/PriceModal'
import sendmodal from '@/components/modals/SendpoyModal'
import printmodal from '@/components/modals/PrintpoyModal'
import clearingModal from '@/components/modals/ClearingModal'
import setnumberModal from '@/components/modals/SetNumberModal'
import { mapGetters, mapActions } from 'vuex'
// import { flatten } from 'lodash'

export default {
  components: {
    'app-content1': content1,
    'app-content2': content2,
    'app-content3': content3,
    'app-content4': content4,
    'app-confirm-model': ConfirmBetModal,
    'app-price-modal': pricemodal,
    'app-send-modal': sendmodal,
    'app-print-modal': printmodal,
    'app-clearing-modal': clearingModal,
    'app-setnumber-modal': setnumberModal
  },
  async beforeMount () {
    this.setLoading(true)
    this.setLoading(false)
    // TOP this.dataInfo = flatten(this.getLotteryList.map(e => e.list)).find(e => e.LottoCatagory.lottoId === parseInt(this.$route.params.id))
  },
  data () {
    return {
      showModal: false,
      showSend: false,
      showPrint: false,
      showSet: false,
      componentKey: 0,
      setNumber: [],
      endTime: false
    }
  },
  watch: {
    setNumber: function (val) {
      this.setNumber = val
      this.showSet = false
    },
    setEndTime: function (val) {
      this.endTime = val
    }
  },
  computed: {
    ...mapGetters(['getLotteryList', 'getInquiryRoundInfomation'])
  },
  methods: {
    ...mapActions(['getInquiryRoundInfomationByID', 'setLoading']),
    toggleExit (toggle) {
      this.showModal = toggle
    },
    togglePrice (toggle) {
      if (toggle) {
        this.showModal = toggle
      } else {
        this.showModal = toggle
        this.componentKey += 1
      }
    },
    toggleSend (toggle) {
      this.showSend = toggle
    },
    togglePrint (toggle) {
      if (toggle) {
        this.showModal = false
        this.showSend = false
      } else {
        this.componentKey += 1
      }
      this.showPrint = toggle
    },
    toggleSet (toggle) {
      this.showSet = toggle
    }
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
